export default "__VITE_ASSET__BdAF2YBu__"